import { Table, IconButton } from '@nimbus-ds/components';
import { PencilIcon, TrashIcon } from '@nimbus-ds/icons';
import { Stack } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';

function ExceptionsTable() {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.table');
  const headers = [
    t('name'),
    t('quantityProducts'),
    t('taxRate'),
    t('actions'),
  ];

  // TODO: get data from API
  const data = [
    {
      id: 1,
      description: 'Excepción 1',
      products: [
        {
          product_id: 78912156,
        },
      ],
      taxRate: '10%',
    },
  ];

  const handleEdit = (id: number) => {
    // TODO: Implement edit functionality
    console.log('Edit exception:', id);
  };

  const handleDelete = (id: number) => {
    // TODO: Implement delete functionality
    console.log('Delete exception:', id);
  };

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          {headers.map((header) => (
            <Table.Cell key={header} backgroundColor="neutral-surface" as="th">
              {header}
            </Table.Cell>
          ))}
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {data.map(({ id, description, products, taxRate }) => (
          <Table.Row key={id}>
            <Table.Cell as="td">{description}</Table.Cell>
            <Table.Cell as="td">
              {t('quantityProducts', { count: products.length })}
            </Table.Cell>
            <Table.Cell as="td">{taxRate}</Table.Cell>
            <Table.Cell as="td">
              <Stack gap="2">
                <IconButton
                  size="2rem"
                  source={<PencilIcon />}
                  onClick={() => handleEdit(id)}
                />
                <IconButton
                  size="2rem"
                  source={<TrashIcon />}
                  onClick={() => handleDelete(id)}
                />
              </Stack>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default ExceptionsTable;
